import Image from 'next/image';

export const PreLoader = () => {
    return (
        <div className="flex items-center justify-center align-center bg-primary h-screen w-screen">
            <Image className="animate-pulse" src="/star-white-icon.svg" alt="Star RV Logo" width={100} height={100} />
        </div>
    );
};
